module.exports = __webpack_public_path__ + "90613d7af.png";